export const m ={
    home: 'ᠲᠡᠷᠢᠭᠦᠨ ᠨᠢᠭᠤᠷ', // 首页
    noData:'ᠣᠳᠣᠬᠠᠨ ᠳᠠᠭᠠᠨ ᠲᠣᠭ᠎ᠠ ᠪᠠᠷᠢᠮᠲᠠ ᠦᠭᠡᠢ！',//暂无数据

    isbn: 'ᠨᠣᠮ ᠤᠨ ᠨᠣᠮᠸ᠍ᠷ ( ISBN )',//书号
    book_name: 'ᠨᠣᠮ ᠤᠨ ᠨᠡᠷ᠎ᠡ',//书名
    press_time: 'ᠨᠣᠮ ᠤᠨ ᠬᠡᠪᠯᠡᠯ ᠦᠨ ᠴᠠᠭ',//出版时间
    author: 'ᠵᠣᠬᠢᠶᠠᠭᠴᠢ ',//作者
    press:'ᠬᠡᠪᠯᠡᠯ ᠤᠨ ᠬᠣᠷᠢᠶ᠎ᠠ',//出版社
    address_name: 'ᠭᠠᠵᠠᠷ ᠣᠷᠣᠨ',//地区
    content_mn:'ᠠᠭᠤᠯᠭ᠎ᠠ',//内容
    address_names: 'ᠲᠣᠳᠣᠷᠬᠠᠶ ᠬᠠᠶ᠋ᠢᠭ',//详细地址
    introduce:'ᠲᠣᠪᠴᠢ ᠲᠠᠨᠢᠯᠴᠠᠭᠤᠯᠭ᠎ᠠ ',//介绍
    book_paper_author:'ᠵᠣᠬᠢᠶᠠᠭᠴᠢ',//作者

    newspaper_periodicals:'ᠰᠤᠨᠢᠨ ',//报刊
    periodical_:'ᠰᠡᠳᠭᠥᠯ',//期刊
    mhtranslate:'ᠬᠢᠲᠠᠳ ᠮᠣᠩᠭᠣᠯ ᠣᠷᠴᠢᠭᠤᠯᠭ᠎ᠠ ᠶᠢᠨ ᠬᠦᠮᠦᠷᠭᠡ',//汉蒙翻译
    allperiodical_:'ᠪᠦᠭᠦᠳᠡ ᠰᠡᠳᠬᠦᠯ',//全部期刊
    allperiodical_copy:'ᠰᠡᠳᠬᠦᠯ',//专题-全部期刊

    proverb:'ᠵᠦᠢᠷ ᠰᠡᠴᠡᠨ ᠦᠭᠡ',//谚语
    riddle:'ᠤᠨᠢᠰᠤᠭ᠎ᠠ',//谜语
    couplet:'ᠬᠣᠣᠰ ᠤᠶᠠᠩᠭ᠎ᠠ',//对联
    knowledge_database:'ᠮᠡᠳᠡᠯᠭᠡ ᠶᠢᠨ ᠬᠦᠮᠦᠷᠭᠡ ',//知识数据库

    book_catalogue:'ᠨᠣᠮ ᠤᠨ ᠭᠠᠷᠴᠠᠭ',//书目录
    newspaper_catalogue:'ᠰᠤᠨᠢᠨ ᠦ ᠭᠠᠷᠴᠠᠭ ',//报刊目录
    periodical:'ᠰᠡᠳᠭᠦᠯ ᠤᠨ ᠭᠠᠷᠴᠠᠭ',//期刊目录
    paper:'ᠦᠭᠦᠯᠡᠯ ᠤᠨ ᠭᠠᠷᠴᠠᠭ  ',//论文目录

    logout: 'ᠨᠡᠪᠲᠡᠷᠡᠯᠲᠠ ᠠᠴᠠ ᠭᠠᠷᠬᠤ', // 退出登陆

    details:'ᠨᠠᠷᠢᠨ ᠠᠭᠤᠯᠭ᠎ᠠ',//详情
    mulan:'ᠭᠠᠷᠴᠠᠭ',//目录
    audiobooks:'ᠳᠠᠭᠤᠲᠤ ᠨᠤᠮ',//有声书
    Ebook:'ᠮᠠᠲ᠋ᠧᠷᠢᠶᠠᠯ',//电子书
    seareturn:'ᠬᠠᠶᠢᠯᠲᠠ ᠶᠢᠨ ᠦᠷ᠎ᠡ ᠳ᠋ᠦᠩ',//搜索结果
    translationresults:'ᠦᠷ᠎ᠡ ᠳ᠋ᠦᠩ',//翻译结果
    aqtkj:'ᠥᠪᠥᠷ ᠮᠣᠩᠭᠣᠯ ᠤᠨ ᠠᠴᠢᠲᠠᠢ ᠰᠢᠨᠵᠢᠯᠡᠭᠡ ᠮᠡᠷᠭᠡᠵᠢᠯ ᠤᠨ ᠬᠢᠵᠠᠭᠠᠷᠲᠤ ᠺᠣᠮᠫᠠᠨᠢ ',//内蒙古阿启泰科技有限公司
    bqsy:'ᠮᠡᠷᠭᠡᠵᠢᠯ ᠬᠠᠩᠭᠠᠪᠠ',//版权所有
    contactNumber:'ᠬᠠᠷᠢᠯᠴᠠᠬᠤ ᠤᠲᠠᠰᠤ ᠄ 18516170412',//联系电话

    booksNumber:'ISBN ᠨᠣᠮᠧᠷ ',//书号
    publish_time:'ᠬᠡᠪᠯᠡᠭᠰᠡᠨ ᠴᠠᠭ ',//出版时间
    pages_number:'ᠨᠢᠭᠤᠷ ᠦᠨ ᠲᠣᠭ᠎ᠠ ',//页数
    words_number:'ᠦᠰᠦᠭ ᠤᠨ ᠲᠣᠭ᠎ᠠ ',//字数
    Price:'ᠦᠨ᠎ᠡ ',//价格

    cancel: 'ᠲᠡᠭᠡᠶ᠎ᠡ', // 取消

    Competentunit:'ᠭᠣᠣᠯ ᠬᠠᠮᠢᠶᠠᠷᠬᠤ ᠨᠢᠭᠡᠴᠢ',//主管单位
    qishu:'ᠬᠤᠭᠤᠴᠠᠭ᠎ᠠ',//期数
    Sponsor:'ᠡᠷᠬᠢᠯᠡᠭᠰᠡᠨ ᠨᠢᠭᠡᠴᠢ',//主办单位
    edit:'ᠨᠠᠶᠢᠷᠠᠭᠤᠯᠤᠭᠰᠠᠨ ᠨᠢ',//编辑
    publish:'ᠬᠡᠪᠯᠡᠭᠦᠯᠦᠭᠰᠡᠨ ᠨᠢ',//出版
    chief_editor:'ᠡᠷᠬᠢᠯᠡᠨ ᠨᠠᠶᠢᠷᠠᠭᠤᠯᠤᠭᠴᠢ',//主编
    deputy_chief_editor:'ᠳᠡᠳ᠋ ᠡᠷᠬᠢᠯᠡᠨ ᠨᠠᠶᠢᠷᠠᠭᠤᠯᠤᠭᠴᠢ',//副主编

    fister_ban:'ᠬᠡᠪᠯᠡᠯ ᠤᠨ ᠳ᠋ᠤᠭᠠᠷ',//第几（）版
    ci:'ᠳ᠋ᠤᠭᠠᠷ',//版次
    selectType:'ᠬᠠᠶᠢᠯᠲᠠ ᠶᠢᠨ ᠠᠩᠭᠢᠯᠠᠯ ᠢᠶᠡᠨ ᠰᠤᠩᠭᠤᠬᠤ  ',//请选择搜索类型
    Under_development:'ᠰᠤᠳᠤᠯᠤᠨ ᠨᠡᠭᠡᠭᠡᠵᠦ ᠪᠠᠶᠢᠭ᠎ᠠ',//正在开发中
    content_Please:'ᠬᠠᠶᠢᠬᠤ ᠠᠭᠤᠯᠭ᠎ᠠ ᠪᠠᠨ ᠲᠠᠭᠯᠠᠭᠠᠷᠠᠢ',//请输入要搜索的内容
    mobile_Please:'ᠭᠠᠷ ᠤᠲᠠᠰᠤᠨ ᠤ ᠨᠣᠮᠧᠷ ᠢᠶᠡᠨ ᠲᠠᠭᠯᠠ',//填写手机号
    telephone_Please:'ᠵᠥᠪ ᠤᠲᠠᠰᠤᠨ ᠨᠣᠮᠧᠷ ᠢᠶᠡᠨ ᠲᠠᠭᠯᠠᠭᠠᠷᠠᠢ',//请填写正确电话号码
    code_to_frequently:'ᠰᠢᠯᠭᠠᠨ ᠪᠠᠲᠤᠯᠠᠬᠤ ᠺᠣᠳ᠋ ᠬᠡᠲᠦ ᠣᠯᠠᠨ ᠶᠠᠪᠤᠭᠤᠯᠵᠤ ᠪᠠᠶᠢᠨ᠎ᠠ ᠂ 1 ᠴᠠᠭ ᠤᠨ ᠳᠠᠷᠠᠭ᠎ᠠ ᠳᠠᠭᠢᠵᠤ ᠲᠤᠷᠰᠢᠭᠠᠷᠠᠶ ︕',//发送验证码太频繁，请1小时后再试！
    code_is_inconsistent:'ᠰᠢᠯᠭᠠᠨ ᠪᠠᠲᠤᠯᠠᠬᠤ ᠺᠣᠳ᠋ ᠢ ᠣᠯᠤᠭᠰᠠᠨ ᠭᠠᠷ ᠤᠲᠠᠰᠤᠨ ᠤ ᠨᠣᠮᠧᠷ ᠪᠠ ᠲᠠᠭᠯᠠᠭᠰᠠᠨ ᠭᠠᠷ ᠤᠲᠠᠰᠤᠨ ᠤ ᠨᠣᠮᠧᠷ ᠨᠢ ᠠᠳᠠᠯᠢ ᠦᠭᠡᠢ',//获取验证码手机号和输入手机号不一致
    verification_code_Please:'ᠰᠢᠯᠭᠠᠨ ᠪᠠᠲᠤᠯᠠᠬᠤ ᠺᠣᠳ᠋ ᠢ ᠲᠠᠭᠯᠠᠭᠠᠷᠠᠢ',//请填写验证码
    collection_Please:' ᠬᠠᠳᠠᠭᠠᠯᠠᠮᠵᠢ  ᠶᠢᠨ ᠭᠠᠵᠠᠷ  ᠢᠶᠠᠨ ᠰᠣᠩᠭᠣᠭᠠᠷᠠ',//请选择馆藏
    code_Incorrect:'ᠰᠢᠯᠭᠠᠨ ᠪᠠᠲᠤᠯᠠᠬᠤ ᠺᠣᠳ᠋ ᠴᠢᠨᠢ ᠪᠤᠷᠤᠭᠤ',//验证码不正确
    page_away:'ᠰᠦᠯᠵᠢᠶ᠎ᠡ  ᠲᠣᠭᠲᠠᠪᠤᠷᠢ ᠦᠭᠡᠢ ᠂ ᠤᠳᠠᠰᠬᠢᠭᠠᠳ ᠳᠠᠬᠢᠨ ᠲᠤᠷᠰᠢᠭᠠᠷᠠᠶ!',//页面溜走了，请稍后重试！


    chinese:' ( ᠬᠢᠲᠠᠳ ) ',//汉语
    Chinese_Mongolian:'( ᠮᠣᠩᠭᠣᠯ )',//蒙古语

    CulturalClass:'ᠰᠣᠶᠣᠯ ᠤᠨ ᠲᠥᠷᠥᠯ',//文化分类
    ResourceClass:'ᠰᠣᠩᠭᠣᠳᠠᠭ ᠤᠷᠠᠨ ᠪᠦᠲᠦᠭᠡᠯ  ᠦᠨ ᠠᠩᠭᠢᠯᠠᠯ',//资源分类(经典分类)
    Red_Literature:'ᠨᠠᠮ ᠬᠤᠪᠢᠰᠬᠠᠯ ᠊ᠤᠨ ᠨᠣᠮ ᠊ᠤᠳ',//红色文献
    Children_songs:'ᠬᠡᠦᠬᠡᠳ ᠊ᠦᠨ ᠠᠷᠠᠳ ᠊ᠤᠨ ᠳᠠᠭᠤᠤ',//儿童民歌

    ChineseMongolianTranslation: 'ᠬᠢᠲᠠᠳ — ᠮᠣᠩᠭᠣᠯ ᠣᠷᠴᠢᠭᠤᠯᠭ᠎ᠠ ᠶᠢᠨ ᠬᠦᠮᠦᠷᠭᠡ',//汉蒙翻译
    MongolianTranslationIn:'ᠮᠣᠩᠭᠣᠯ — ᠬᠢᠲᠠᠳ ᠣᠷᠴᠢᠭᠤᠯᠭ᠎ᠠ ᠶᠢᠨ ᠬᠦᠮᠦᠷᠭᠡ',//蒙汉翻译
    Listen_to_others:'ᠪᠤᠰᠤᠳ ᠤᠨ ᠪᠦᠲᠦᠭᠡᠯ ᠢ ᠰᠣᠨᠢᠷᠬᠠᠬᠤ',//试听他人
    source: 'ᠢᠷᠡᠯᠲᠡ ',//来源
    Latest_news:'ᠬᠠᠮᠤᠭ ᠤᠨ ᠰᠢᠨ᠎ᠡ ᠰᠣᠨᠢᠨ ᠮᠡᠳᠡᠭᠡ',//最新新闻

    dqgc_onw:' ᠲᠤᠬᠠᠢ ᠵᠢᠨ ᠰᠠᠩ  ᠡᠬᠡ ᠰᠤᠷᠪᠤᠯᠵᠢ  ᠶ᠋ᠢ ᠠᠰᠢᠭᠯᠠᠬᠤ ᠡᠷᠬᠡ   ᠣᠳᠣᠬᠠᠨ  ᠳ᠋ᠤ᠌  ᠪᠠᠨ ᠦᠭᠡᠢ ᠪᠠᠶ᠋ᠢᠨ᠎ᠠ',//当前馆藏未分配资源权限
    dagc_two:'ᠲᠤᠰ ᠬᠡᠷᠡᠭᠯᠡᠭᠴᠢ ᠵᠢᠨ ᠠᠵᠢᠯ ᠊ᠤᠨ ᠭᠠᠵᠠᠷ  ᠪᠤᠷᠤᠭᠤ ',//该用户不在当前单位！
    dagc_sec:'ᠬᠡᠷᠡᠭᠯᠡᠭᠴᠢ ᠵᠢᠨ ᠡᠷᠬᠡ  ᠶ᠋ᠢ ᠬᠠᠰᠤᠪᠠ',//用户已禁用
    dagc_four:'ᠬᠡᠷᠡᠭᠯᠡᠭᠴᠢ  ᠮᠡᠳᠡᠭᠡᠯᠡᠯ ᠵᠢᠡᠨ ᠤᠰᠠᠳᠬᠠᠭᠰᠠᠨ ᠪᠠᠶ᠋ᠢᠨ᠎ᠠ',//用户已注销
    dagc_sie:'ᠲᠤᠰ ᠪᠠᠶᠢᠭᠤᠯᠤᠯᠭ᠎ᠠ ᠣᠳᠣᠬᠠᠨ ᠳᠤ ᠪᠡᠨ ᠬᠡᠷᠡᠭᠯᠡᠬᠦ ᠡᠷᠬᠡ ᠦᠭᠡᠢ',//本单位未开通此权限

    name_title: 'ᠨᠡᠷ᠎ᠡ ',//名称
    gjc:'ᠵᠠᠩᠭᠢᠯᠠᠭ᠎ᠠ ᠶᠢᠨ ᠦᠭᠡ ',//关键词
    zhaiyao:'ᠲᠣᠪᠴᠢᠯᠠᠯ ',//摘要
    lunType:'ᠥᠭᠦᠯᠡᠯ ᠦᠨ ᠲᠥᠷᠥᠯ ',//论文类型
    downNum:'ᠪᠠᠭᠤᠯᠭᠠᠭᠰᠠᠨ ᠤᠳᠠᠭ᠎ᠠ',//下载量
    yinyNum:'ᠡᠰᠢᠯᠡᠭᠰᠡᠨ ᠤᠳᠠᠭ᠎ᠠ',//引用量
    readingNum:'ᠤᠩᠰᠢᠯᠭ᠎ᠠ ᠶᠢᠨ ᠬᠡᠮᠵᠢᠶ᠎ᠡ',//阅读量

    wlmq:'ᠤᠯᠠᠭᠠᠨᠮᠥ᠋ᠴᠢᠷ',//乌兰牧骑
    literature:'ᠰᠣᠶᠣᠯ ᠲᠡᠦᠬᠡ ᠶᠢᠨ ᠮᠠᠲ᠋ᠧᠷᠢᠶᠠᠯ',//文史资料
    btjrg_video:'ᠪᠠᠲᠤᠵᠢᠷᠭᠠᠯ ᠦᠨ ᠮᠣᠷᠢᠨ ᠬᠤᠭᠤᠷ ᠤᠨ ᠬᠢᠴᠢᠶᠡᠯ',//巴图吉日嘎拉马头琴教学
    sularong_video:'ᡀᠠᠰᠦ᠋ᠷᠦᠩ ᠦᠨ ᠪᠢᠴᠢᠯᠭᠡ',//拉苏荣视频专题

    _Mongolian:"ᠮᠣᠩᠭᠣᠯ ᠬᠡᠯᠡ",//蒙古文
    _Chinese:"ᠬᠢᠲᠠᠳ ᠬᠡᠯᠡ",//中文
    _English:"ᠠᠩᠭ᠍ᠯᠢ ᠬᠡᠯᠡ",//英文
    _language: 'ᠦᠭᠡ ᠬᠡᠯᠡ',//语言
    dictionary_fanyi:'ᠲᠣᠯᠢ ᠪᠢᠴᠢᠭ ᠦᠨ ᠬᠥᠮᠥᠷᠭᠡ ( ᠣᠷᠴᠢᠭᠤᠯᠭ᠎ᠠ )',//词典数据库（翻译）

    copy_text:'ᠺᠣᠪᠢᠳᠠᠬᠤ',//拷贝
    search: 'ᠬᠠᠶᠢᠬᠤ',//搜索
    file_page: 'ᠪᠢᠴᠢᠭ ᠮᠠᠲ᠋ᠧᠷᠢᠶᠠᠯ ᠦᠨ ᠨᠢᠭᠤᠷ ᠦᠨ ᠳ᠋ᠤᠭᠠᠷ',//文件页码
    infor_page:'ᠠᠭᠤᠯᠭ᠎ᠠ ᠶᠢᠨ ᠨᠢᠭᠤᠷ ᠦᠨ ᠳ᠋ᠤᠭᠠᠷ',//资料/书籍页码
    no_data: 'ᠣᠳᠣᠬᠠᠨ ᠳᠤ ᠪᠡᠨ ᠲᠣᠭ᠎ᠠ ᠪᠠᠷᠢᠮᠲᠠ ᠦᠭᠡᠢ',//暂无数据
    text_order_copy:'ᠠᠭᠤᠯᠭ᠎ᠠ ᠶᠢ ᠺᠣᠪᠢᠲᠠᠪᠠ',//文本已复制到剪贴板
    gend_more: 'ᠨᠡᠩ ᠤᠯᠠᠨ ',//更多

    please_start_lang:'ᠲᠣᠯᠣᠭᠠᠢ ᠦᠭᠡ ᠶᠢᠨ ᠬᠡᠯᠡ ᠶᠢ ᠰᠣᠩᠭᠣᠭᠠᠷᠠᠢ',//请选择头词语言
    please_end_lang:'ᠲᠠᠶᠢᠯᠪᠤᠷᠢ ᠦᠭᠡ ᠶᠢᠨ ᠬᠡᠯᠡ ᠶᠢ ᠰᠣᠩᠭᠣᠭᠠᠷᠠᠢ',//请选择解释语言
    start_tc_lang:'ᠲᠣᠯᠣᠭᠠᠢ ᠦᠭᠡ ᠶᠢᠨ ᠬᠡᠯᠡ',//头词语言
    end_js_lang:'ᠲᠠᠶᠢᠯᠪᠤᠷᠢ ᠦᠭᠡ ᠶᠢᠨ ᠬᠡᠯᠡ',//解释语言
    no_permission:'ᠬᠡᠷᠡᠭᠯᠡᠬᠦ ᠡᠷᠬᠡ ᠦᠭᠡᠢ ᠂ ᠭᠠᠷ ᠤᠲᠠᠰᠤ ᠶᠢᠨ ᠬᠡᠪ ᠢᠶᠡᠷ ᠦᠵᠡᠭᠡᠷᠡᠢ ᠃',//没有权限，请使用移动端查阅。
    intelligent_translation:'ᠣᠶᠣᠨ ᠣᠷᠴᠢᠭᠤᠯᠭ᠎ᠠ',//智能翻译
    please_input_translation:'ᠠᠭᠤᠯᠭ᠎ᠠ ᠪᠡᠨ ᠪᠢᠴᠢᠭᠡᠷᠡᠢ',//请输入文本
    please_targetLang:'ᠣᠷᠴᠢᠭᠤᠯᠬᠤ ᠬᠡᠯᠡ ᠪᠡᠨ ᠰᠣᠩᠭᠣᠭᠠᠷᠠᠢ',//请选择目标语言
    goto: 'ᠬᠦᠷᠬᠦ',//跳至
    p: 'ᠨᠢᠭᠤᠷ',//页
    dictionary:'ᠲᠣᠯᠢ',//词典
    copy:'ᠺᠣᠪᠢᠳᠠᠬᠤ',//复制
    clear: ' ᠠᠷᠢᠯᠭᠠᠬᠤ',//清空
    translate:'ᠣᠷᠴᠢᠭᠤᠯᠬᠤ',//翻译
    paste:'ᠨᠠᠭᠠᠬᠤ',//粘贴

    aqt_whysdsj:'ᠠᠴᠢᠲᠠᠢ ᠰᠣᠶᠣᠯ ᠤᠷᠠᠯᠢᠭ ᠤᠨ ᠲᠣᠮᠣ ᠳ᠋ᠠᠶᠢᠲ᠋ᠠ',//阿启泰文化艺术大数据
    aqt_whysdsjyzzy:'ᠠᠴᠢᠲᠠᠢ ᠰᠣᠶᠣᠯ ᠤᠷᠠᠯᠢᠭ ᠤᠨ ᠲᠣᠮᠣ ᠳ᠋ᠠᠶᠢᠲ᠋ᠠ ᠰᠢᠯᠢᠳᠡᠭ ᠡᠬᠢ ᠰᠤᠷᠪᠤᠯᠵᠢ ᠶᠢᠨ ᠬᠥᠮᠥᠷᠭᠡ',//阿启泰文化艺术大数据优质资源库
    Mongolian:'ᠮᠣᠩᠭᠣᠯ ᠬᠡᠯᠡ',//蒙古文

    mobile_phone_title:'ᠭᠠᠷ ᠤᠲᠠᠰᠤ ᠶᠢᠨ ᠬᠡᠪ',//移动端

    journal_name:'ᠰᠡᠳᠬᠦᠯ ᠦᠨ ᠨᠡᠷ᠎ᠡ',//期刊名称
    journal_keyword:'ᠵᠠᠩᠭᠢᠯᠠᠭ᠎ᠠ ᠶᠢᠨ ᠦᠭᠡ',//期刊关键词
    editor:'ᠡᠷᠬᠢᠯᠡᠨ ᠨᠠᠶᠢᠷᠠᠭᠤᠯᠤᠭᠴᠢ / ᠭᠣᠣᠯᠯᠠᠨ ᠨᠠᠶᠢᠷᠠᠭᠤᠯᠤᠭᠴᠢ',//主编
    fu_editor:'ᠳᠡᠳ᠋ ᠡᠷᠬᠢᠯᠡᠨ ᠨᠠᠶᠢᠷᠠᠭᠤᠯᠤᠭᠴᠢ / ᠳᠡᠳ᠋ ᠭᠣᠣᠯᠯᠠᠨ ᠨᠠᠶᠢᠷᠠᠭᠤᠯᠤᠭᠴᠢ',//副主编
    book_title:'ᠰᠤᠳᠤᠷ ᠨᠣᠮ',//书籍
    mazy_title:'ᠰᠡᠳᠬᠦᠯ ᠦᠨ ᠨᠡᠷ᠎ᠡ',//杂志名称
    mazy_autor:'ᠵᠣᠬᠢᠶᠠᠭᠴᠢ',//作者（期刊作者）

    _zh: 'ᠬᠢᠲᠠᠳ',//中文
    _mn: 'ᠮᠣᠩᠭᠣᠯ ᠬᠡᠪ',//蒙文端
    contact_information: 'ᠬᠠᠷᠢᠯᠴᠠᠬᠤ ᠠᠷᠭ᠎ᠠ ᠄ 1072913745@qq.com',//联系方式
    chainebookclass:'图书分类',//图书分类
}
